var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-total-edit-content-wrapper",
    {
      attrs: { value: _vm.currentTab },
      on: {
        input: function ($event) {
          return _vm.$emit("update:currentTab", $event)
        },
      },
    },
    [
      _c(
        "w-list",
        [
          _vm._l(_vm.value.Columns, function (column, i) {
            return _c("app-total-edit-column", {
              key: i,
              attrs: {
                browse: _vm.browse,
                column: column,
                model: _vm.model,
                "can-delete": _vm.value.Columns.length > 1,
                "is-editing": _vm.toEditColumn == column,
              },
              on: {
                delete: function ($event) {
                  return _vm.removeColumn(i)
                },
                edit: function ($event) {
                  return _vm.editColumn(i)
                },
              },
            })
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.addColumn()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-column")))]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }